import ajax from '@/utils/ajax';
import {
  ROBOT_ANSWER_REPORT,
  IM_MSG_TRACING_REPORT,
} from '@/utils/api';
import uuid from '../imsdk/utils/uuid';
import { isPrivate } from '@/utils/env';

/**
 * 机器人上报
 */

function report(data) {
  return ajax.post(ROBOT_ANSWER_REPORT, data);
}

function beforeRobotMsgReport(imsdkMessage) {
  /* eslint-disable max-len */
  const seqId = imsdkMessage?.msg_send_req?.msg_send_msg?.msg_msg_head?.msg_third_app_info?.bytes_third_app_buf?.bytes_crm_buf?.msg_attributes_info?.str_qidian_msg_unique_id ?? null;
  this.globalData?.reception?.isRobot && seqId && report({
    seqId,
    kfuin: this.wpaDetail.kfuin,
    robotId: this.globalData.reception.robotId,
    direction: 1,
    cid: this.to.user_id,
    timestamp: Date.now(),
  });
}
function afterRobotMsgReport(res) {
  this.globalData?.reception?.isRobot && res.str_qidian_msg_unique_id && report({
    seqId: res.str_qidian_msg_unique_id,
    kfuin: this.wpaDetail.kfuin,
    robotId: this.globalData.reception.robotId,
    direction: 2,
    cid: this.to.user_id,
    timestamp: Date.now(),
  });
}
// message MsgTracingEvent {
// 	string check_id = 1;	// 必填: 企点唯一消息ID（全局）和SLA复用
// 	uint64 kfuin = 2;	// 必填: 主号
// 	uint64 kfext = 3;	// 必填: 工号
// 	string from_term = 4;	// 必填: 消息来源终端类型：ios:1 android:2 pc:3 ,现有
// 	string cur_mod_name = 5;	// 必填: 当前服务(模块)名 'webim_v2'
// 	string next_mod_name = 6;	// 一般为下一跳的服务(模块)，若无则默认为空 'websocket'
// 	string local_ip = 7;			// 必填: ip 地址, 如：10.10.11.12 || ''
// 	uint64 event_time_ms = 8;	// 必填: 事件发生时间（毫秒） Date.now()
// 	string event_name = 9;		// 必填: 事件名 'msg_send_success' 'msg_receive' 'msg_send_error'
// 	uint32 evnet_ret_code = 10;	// 必填: 事件错误码（0: 正常， 非0: 异常）-1 发送消息失败
// 	string event_ret_msg = 11;	// 必填: 事件错误信息 可以为：''
// 	uint64 event_cost_ms = 12;	// 必填: 事件处理耗时（毫秒）发送成功/失败两种场景

// 	string event_log_info = 13;	// 用于存放额外的事件日志信息，可用于自定义关键的打点信息，比如某个变量的值
// 	string extend_info = 14;		// 扩展字段，用于统一存放结构化的信息, 如json字符串格式
// 	string gseq = 15;	// 必填: 用于串联日志（对接日志系统，如cls），用于日志排查定位具体问题 如：客户端若无gseq, 则可直接用check_id
// 	string report_source = 16;	// 必填: 上报来源类型: ios; android; pc; webim; imsdk; min_program_plugin; openapi等
// }
//
/* eslint-disable camelcase */
export function msgTracingEvent(array) {
  // 私有化关闭上报
  if (isPrivate) {
    return false;
  }
  const data = array.map((item) => {
    const check_id = uuid();
    return {
      qidian_msg_unique_id: item.check_id || check_id,
      kfuin: Number(item.kfuin),
      kfext: Number(item.kfext),
      from_term: 5,
      cur_mod_name: 'webim_v2',
      next_mod_name: 'c-imsdk',
      local_ip: '',
      event_time_ms: Date.now(),
      event_name: item.event_name || 'msg_send_success',
      evnet_ret_code: item.evnet_ret_code || 0,
      event_ret_msg: '',
      event_cost_ms: item.event_cost_ms || 0,
      event_log_info: '',
      extend_info: '',
      gseq: item.check_id || check_id,
      channel_type: 4, // webim 固定是4
      report_source: 'webim',
      msg_time_ms: Math.floor(item.msg_time_ms) || Date.now(),
      msg_dir: item.msg_dir || 'c2b',
    };
  });
  console.log('msgTracingEvent', data);
  return ajax.post(IM_MSG_TRACING_REPORT, {
    size: data.length,
    data,
  });
}

export const robotReport = {
  before: beforeRobotMsgReport,
  after: afterRobotMsgReport,
};

